import { render, staticRenderFns } from "./SamplePage.vue?vue&type=template&id=442f65f2&scoped=true&"
import script from "./SamplePage.vue?vue&type=script&lang=ts&"
export * from "./SamplePage.vue?vue&type=script&lang=ts&"
import style0 from "./SamplePage.vue?vue&type=style&index=0&id=442f65f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442f65f2",
  null
  
)

export default component.exports